/**
 * CRM v2 — Lembrete de atividade (Bloco C): store React Query da configuração.
 *
 * Contrato: GET/PUT /api/v1/crm/config/lembrete — payload { config }.
 * Mesmo padrão do reciclagem-config-store.
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api, hasToken } from '@/lib/api';

export interface LembreteConfig {
  /** Liga/desliga o lembrete inteiro. */
  ativo: boolean;
  /** Quantos minutos antes da hora agendada avisar (valores do catálogo de tempos). */
  antecedenciaMin: number;
}

// CA-6 (mig 413): as opções da UI agora vêm do catálogo crm_lembrete_tempos
// (hook useLembreteTempos do crm-store) — a constante ANTECEDENCIA_OPCOES
// (15/30/60 hardcoded) morreu junto com a gêmea do servidor.

const KEY = ['v1', 'crm', 'config', 'lembrete'] as const;

export function useLembreteConfig() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => api.get<{ config: LembreteConfig }>('/api/v1/crm/config/lembrete'),
    enabled: hasToken(),
    staleTime: 60_000,
    select: (data) => data.config,
  });
}

export function useLembreteConfigActions() {
  const qc = useQueryClient();
  const salvar = useMutation({
    mutationFn: (body: Partial<LembreteConfig>) =>
      api.put<{ config: LembreteConfig }>('/api/v1/crm/config/lembrete', body),
    onSuccess: (data) => {
      qc.setQueryData(KEY, data);
      void qc.invalidateQueries({ queryKey: KEY });
    },
  });
  return { salvar };
}
